module.exports = __webpack_public_path__ + "img/materials-and-equipments-requests-hover.ec5b472e.svg";